import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Router } from 'react-router-dom';
import history from "./history";
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import * as WebFontLoader from 'webfontloader';
import Amplify from 'aws-amplify';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

Amplify.configure({
  Auth: {
      mandatorySignIn: true,
      region: 'us-east-2',
      userPoolId: 'us-east-2_MBCywyO8N',
      userPoolWebClientId: 'isne18ikkvc0qs7aptlf25oi6',
  }
});

WebFontLoader.load({
  google: {
      families: ['Roboto:300,400,500,700', 'Material Icons'],
  },
});


  ReactDOM.render(
    <Router history={history}>
        <App />
    </Router>,
    rootElement);
reportWebVitals();
